import React, {useContext, useLayoutEffect, useRef, useState} from "react";
import {FolienHoeheKontext} from "./FolienHoehe.js";
import HeaderWithHelp from "../../SalesAnalysis/HeaderWithHelp.jsx";

/**
 * Gemeinsamer Rahmen jeder Folie der Erklärung "So rechnet der Bereich"
 * (Auftrag S7): Überschrift mit Nummer, zwei bis drei erklärende Sätze,
 * darunter die Grafik und ganz unten die Leseanleitung "So liest man das".
 * Bewusst schlank gehalten, damit jede Folie bei 1440 px als Ganzes in einen
 * Screenshot passt.
 */
export default function FolieLayout({nummer, titel, hilfe, text, leseHinweis, breiterText = false, children}) {
    // Die Nummer vergibt der Rahmen aus der Position, damit sie beim
    // Aus- oder Einblenden einer Folie nie falsch steht (Auftrag #59).
    const {inhalt, nummer: nummerAusRahmen} = useContext(FolienHoeheKontext);
    const angezeigteNummer = nummerAusRahmen ?? nummer;
    const kopfRef = useRef(null);
    const hinweisRef = useRef(null);
    const [grafikHoehe, setGrafikHoehe] = useState(null);

    // Was nach Überschrift, Text und Lesehinweis an Höhe übrig bleibt, bekommt
    // die Grafik (Auftrag #59) - bei jeder Änderung der Fensterhöhe neu.
    useLayoutEffect(() => {
        if (!inhalt) {
            return;
        }
        const kopf = kopfRef.current?.offsetHeight ?? 0;
        const hinweis = hinweisRef.current ? hinweisRef.current.offsetHeight + 16 : 0;
        setGrafikHoehe(Math.max(160, Math.floor(inhalt - kopf - hinweis - 36)));
    }, [inhalt, text]);

    return (
        <FolienHoeheKontext.Provider value={{inhalt, grafik: grafikHoehe, nummer: nummerAusRahmen}}>
        <div className="cosmos-erklaerung-folie">
            <div ref={kopfRef}>
            <div className="d-flex align-items-start gap-2 mb-2">
                <span className="badge text-bg-light border flex-shrink-0" style={{fontSize: "0.8rem"}}>
                    {angezeigteNummer}
                </span>
                <h3 className="h5 mb-0">
                    <HeaderWithHelp help={hilfe}>{titel}</HeaderWithHelp>
                </h3>
            </div>
            {text && <div className="mb-3" style={{maxWidth: breiterText ? "none" : 760}}>{text}</div>}
            </div>
            {/* Waagerecht scrollbar statt gestaucht (Befund S23, Sichtprüfung 3): die
                eigenen SVG-Schaubilder tragen selbst eine Mindestbreite, damit ihre
                Beschriftungen auch bei 390 px lesbar bleiben; wer sie ganz sehen will,
                scrollt seitlich statt eine winzige, unlesbare Fassung zu bekommen. */}
            <div className="cosmos-erklaerung-grafik" style={{overflowX: "auto"}}>
                {children}
            </div>
            {leseHinweis && (
                <div ref={hinweisRef} className="small text-muted mt-3 d-flex align-items-start gap-2">
                    <span className="fw-semibold flex-shrink-0">So liest man das:</span>
                    <span>{leseHinweis}</span>
                </div>
            )}
        </div>
        </FolienHoeheKontext.Provider>
    );
}
